// This file is auto-generated by running `yarn svg:process`

import * as React from 'react'

export const LargeCheckmarkSvg = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => {
  return (
    <svg
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      height={props.height}
      width={props.width}
      fill="none"
    >
      <path
        d="M48.363 65.625h-4.594a3.139 3.139 0 01-2.533-1.291l-9.69-13.419 2.533-1.83L43.767 62.5h4.595L65.87 35.095l2.634 1.685-17.508 27.406a3.117 3.117 0 01-2.633 1.439z"
        fill={props.fill}
      />
      <circle cx={50} cy={50} r={43.5} stroke={props.fill} strokeWidth={3} />
    </svg>
  )
}
